import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import { EditorState, convertToRaw } from "draft-js";
import { Alert } from "@mui/material";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import apiUrl from "../api";

import { ContentState } from "draft-js";

import "./GiveTransactionButton.css";
import DraftEditor from "../Editor/DraftEditor";
import PopUpWindow from "../popUpWindow/PopUpWindow";

function formatAmount(amount) {
  return amount.toFixed(2);
}

const GiveTransactionButton = (props) => {
  const [selectedTransaction, setSelectedTransaction] = useState(
    props.selectedTransaction
  );

  const currencyOptions = [
    {
      value: "EUR",
      label: "€",
    },
    {
      value: "USD",
      label: "$",
    },
    {
      value: "GBP",
      label: "£",
    },
    {
      value: "JPY",
      label: "¥",
    },
    {
      value: "RUB",
      label: "₽",
    },
  ];

  const [properties, setProperties] = useState([]);
  const [reasons, setReasons] = useState([]);
  const [methodsOfPayment, setMethodsOfPayment] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // Convert HTML string to EditorState
  const contentBlock = htmlToDraft(
    selectedTransaction ? selectedTransaction.notes : "<p></p>"
  );
  const contentState = ContentState.createFromBlockArray(
    contentBlock.contentBlocks
  );
  const editorState = EditorState.createWithContent(contentState);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [newNote, setNewNote] = useState(editorState);



  const [currency, setCurrency] = useState(
    selectedTransaction
      ? selectedTransaction.currency
      : {
          value: "EUR",
          label: "€",
        }
  );
  const user = JSON.parse(localStorage.getItem("user"));

  const [popUpWindowIsOpen, setPopUpWindowIsOpen] = useState(false);


  const handleClick = () => {
    setPopUpWindowIsOpen(true);
  };
  const handleSendSubmit = async (e) => {
    e.preventDefault();

    if (!amount || amount === "" || amount === "0") {
      setErrorMessage("Please enter an amount.");
      return;
    }

    if (!selectedProperty || selectedProperty === "") {
      setErrorMessage("Please select a property.");
      return;
    }

    if (!selectedReason || selectedReason === "") {
      setErrorMessage("Please select a reason.");
      return;
    }

    if (!selectedMethodOfPayment || selectedMethodOfPayment === "") {
      setErrorMessage("Please select a method of payment.");
      return;
    }

    if (!selectedCompany || selectedCompany === "") {
      setErrorMessage("Please select a business account.");
      return;
    }

    const data = {
      amount: parseFloat(amount),
      currency: currency.value,
      owner: props.owner || null,
      company: selectedCompany.value._id,
      property: selectedProperty.value._id,
      reason: selectedReason.value._id,
      payment_method: selectedMethodOfPayment.value._id,
      notes: draftToHtml(convertToRaw(newNote.getCurrentContent())),
    };

    try {
      const response = await axios.post(
        `${apiUrl}/transaction/send-money-auto/`,
        data,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      setSuccessMessage(response.data.message);
      setErrorMessage("");

      setTimeout(() => {
        setPopUpWindowIsOpen(false);
        setSuccessMessage("");
        setErrorMessage("");
        if (props.onSuccess) {
          props.onSuccess();
        }
      }, 1000);
    } catch (error) {
      setSuccessMessage("");
      setErrorMessage(error.response.data.message);
    }
  };





  const [amount, setAmount] = useState(
    selectedTransaction
      ? selectedTransaction.amount < 0
        ? selectedTransaction.amount * -1
        : selectedTransaction.amount
      : ""
  );

  const [selectedProperty, setSelectedProperty] = useState(
    selectedTransaction ? selectedTransaction.property : ""
  );

  const [selectedReason, setSelectedReason] = useState(
    selectedTransaction ? selectedTransaction.reason : ""
  );

  const [selectedMethodOfPayment, setSelectedMethodOfPayment] = useState(
    selectedTransaction ? selectedTransaction.methodOfPayment : null
  );

  const [selectedCompany, setSelectedCompany] = useState(
    selectedTransaction ? selectedTransaction.company : ""
  );


  const handleBlur = () => {
    if (amount) {
      setAmount(formatAmount(parseFloat(amount)));
    }
  };

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/property/getPropertiesNames`,
          {
            headers: {
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        setProperties(response.data.propertiesNames);
        setSelectedProperty(
          selectedTransaction
            ? selectedTransaction.property
            : {
                value: response.data.propertiesNames.find(
                  (property) => property.name === "Rhodes Holidays Office"
                ),
                label: response.data.propertiesNames.find(
                  (property) => property.name === "Rhodes Holidays Office"
                ).name,
              }
        );
      } catch (error) {
        console.log(error);
      }
    };

    const fetchReasons = async () => {
      try {
        const response = await axios.get(`${apiUrl}/transaction-reason/`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        });
        setReasons(response.data.transactionReasons);
      } catch (error) {
        console.error("Failed to fetch reasons: ", error);
      }
    };

    const fetchMethodsOfPayment = async () => {
      try {
        const response = await axios.get(`${apiUrl}/payment-method/`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        });
        setMethodsOfPayment(response.data.paymentMethods);
        setSelectedMethodOfPayment({
          value: response.data.paymentMethods.find(
            (method) => method.title === "Cash"
          ),
          label: response.data.paymentMethods.find(
            (method) => method.title === "Cash"
          ).title,
        });
      } catch (error) {
        console.error("Failed to fetch methods of payment: ", error);
      }
    };

    const fetchCompanies = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${apiUrl}/company`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        });
        setCompanies(response.data.companies);
        setSelectedCompany({
          value: response.data.companies[0],
          label: `${response.data.companies[0].name} | ${response.data.companies[0].taxId} | ${response.data.companies[0].balance}€ | ${response.data.companies[0].iban}`,
        });
        setIsLoading(false);
      } catch (error) {
        console.log(error);
      }
    };

    fetchReasons();
    fetchMethodsOfPayment();
    fetchProperties();
    fetchCompanies();
  }, [selectedTransaction, user.token]);

  return (
    <div className={"give-transaction-form-wrapper"}>
      {popUpWindowIsOpen && !isLoading && (
        <PopUpWindow
            onClose={() => {
                setPopUpWindowIsOpen(false);
            }}
            unfocusClose={true}
        >
          <form
            className={"transaction-form"}
            onSubmit={
              handleSendSubmit
            }
        >
          <div className="transaction-form-amount">
            <input
              type="number"
              className="transaction-form-amount__input"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              onBlur={handleBlur} // Format the amount when the user unfocuses
              placeholder="00,00"
              step={0.01}
              min={0}
              style={{
                width: amount
                  ? `${formatAmount(parseFloat(amount)).length * 25}px`
                  : "150px",
              }}
            />
            <Select
              className="transaction-form-amount__currency"
              value={currency}
              onChange={(e) => setCurrency(e)}
              options={currencyOptions}
              styles={{
                control: (base) => ({
                  ...base,
                  border: "none",
                  boxShadow: "none",
                }),

                indicatorSeparator: (base) => ({
                  ...base,
                  display: "none",
                }),

                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? "var(--primary-color)"
                    : base.backgroundColor,
                  color: state.isSelected ? "white" : base.color,
                }),
              }}
            />
          </div>

          <div className="transaction-form-company">
            <label htmlFor="company" className="form-field-label">
              Business Account:
            </label>
            <Select
              options={companies.map((company) => ({
                value: company,
                label: `${company.name} | ${company.taxId} | ${company.balance}€ | ${company.iban}`,
              }))}
              value={selectedCompany}
              onChange={(selected) => {
                setSelectedCompany(selected);
              }}
              isClearable
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary: "var(--primary-color)",
                  primary25: "var(--secondary-color)",
                },
              })}
              styles={{
                container: (base) => ({
                  ...base,
                  width: "100%",
                }),
                control: (base) => ({
                  ...base,
                  width: "100%",
                }),
                indicatorSeparator: (base) => ({
                  ...base,
                  display: "none",
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? "var(--primary-color)"
                    : base.backgroundColor,
                  color: state.isSelected ? "white" : base.color,
                }),
              }}
            />
          </div>

   

          {/* Partners */}


          <div className="transaction-form-reason">
            <label htmlFor="reason" className="form-field-label">
              Reason:
            </label>
            <Select
              id="reason"
              name="reason"
              value={selectedReason}
              onChange={(e) => setSelectedReason(e)}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary: "var(--primary-color)",
                  primary25: "var(--secondary-color)",
                },
              })}
              options={reasons.map((reason) => ({
                value: reason,
                label: reason.title,
              }))}
              isClearable
              styles={{
                container: (base) => ({
                  ...base,
                  width: "100%", // Ensure container takes 100% width
                }),
                control: (base) => ({
                  ...base,
                  width: "100%", // Ensure control takes 100% width
                }),
                indicatorSeparator: (base) => ({
                  ...base,
                  display: "none",
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? "var(--primary-color)"
                    : base.backgroundColor,
                  color: state.isSelected ? "white" : base.color,
                }),
              }}
            />
          </div>

          <div className="transaction-form-method-of-payment">
            <label htmlFor="methodOfPayment" className="form-field-label">
              Method of Payment:
            </label>
            <Select
              id="methodOfPayment"
              name="methodOfPayment"
              value={selectedMethodOfPayment}
              onChange={(e) => setSelectedMethodOfPayment(e)}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary: "var(--primary-color)",
                  primary25: "var(--secondary-color)",
                },
              })}
              options={methodsOfPayment.map((method) => ({
                value: method,
                label: method.title,
              }))}
              isClearable
              styles={{
                container: (base) => ({
                  ...base,
                  width: "100%", // Ensure container takes 100% width
                }),
                control: (base) => ({
                  ...base,
                  width: "100%", // Ensure control takes 100% width
                }),
                indicatorSeparator: (base) => ({
                  ...base,
                  display: "none",
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? "var(--primary-color)"
                    : base.backgroundColor,
                  color: state.isSelected ? "white" : base.color,
                }),
              }}
            />
          </div>
          <div className="transaction-form-preperty">
            <label htmlFor="property" className="form-field-label">
              Property:
            </label>

            <Select
              id="property"
              name="property"
              value={selectedProperty}
              onChange={(e) => setSelectedProperty(e)}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary: "var(--primary-color)",
                  primary25: "var(--secondary-color)",
                },
              })}
              options={properties.map((property) => ({
                value: property,
                label: property.name,
              }))}
              isClearable
              styles={{
                container: (base) => ({
                  ...base,
                  width: "100%", // Ensure container takes 100% width
                }),
                control: (base) => ({
                  ...base,
                  width: "100%", // Ensure control takes 100% width
                }),
                indicatorSeparator: (base) => ({
                  ...base,
                  display: "none",
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? "var(--primary-color)"
                    : base.backgroundColor,
                  color: state.isSelected ? "white" : base.color,
                }),
              }}
            />
          </div>
          <div className="transaction-form-notes">
            <label htmlFor="notes" className="form-field-label">
              Notes
              <span
                style={{
                  color: "var(--primary-color)",
                  fontSize: "15px",
                  fontWeight: "400",
                }}
              >
                (optional)
              </span>
              :
            </label>

            <DraftEditor
              editorState={newNote}
              setEditorState={setNewNote}
              autoFocus={false}
            />
          </div>
          {successMessage && <Alert severity="success">{successMessage}</Alert>}
          {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
          <div className="transaction-form-submit">
            <div className="form-group">
              <div className="form-field">
                <button
                  type="submit"
                  className="add-ticket-button__button"
                  style={{
                    backgroundColor: props.color || "var(--primary-color)",
                    color: props.textColor || "var(--primary-text-color)",
                    fontSize: props.fontSize || "15px",
                    fontWeight: props.fontWeight || "600",
                    width: props.width || "100%",
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </form>
      </PopUpWindow>
        )}

      <button
                className="add-ticket-button__button"
                style={{
                  backgroundColor: props.color || "var(--primary-color)",
                  color: props.textColor || "var(--primary-text-color)",
                  fontSize: props.fontSize || "15px",
                  fontWeight: props.fontWeight || "600",
                    width: props.width || "100%",
                }}
                onClick={handleClick}
              >

                <span>Give (no balance influence)</span>
              </button>
    </div>
  );
};

export default GiveTransactionButton;
